/**
 * Created by Rodrigo Quesada on 04/01/17.
 */
export class InstitutionContact {
    public phone?: string;
    public fax?: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/common/values/institution-contact.class.ts